module.exports = __webpack_public_path__ + "static/img/bodyinduction.9a44ffd7.png";